import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col justify-center items-center px-6 py-20 md:py-32 bg-cream-100 overflow-hidden" data-id="element-62">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-40" data-id="element-63">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-terracotta/10 blur-3xl" data-id="element-64" />
        <div className="absolute top-[40%] -left-[10%] w-[400px] h-[400px] rounded-full bg-terracotta/5 blur-3xl" data-id="element-65" />
      </div>

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-66">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block mb-6 text-sm font-medium tracking-[0.2em] text-terracotta uppercase" data-id="element-67">
          MIS MANOS, MI CALMA
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal mb-6 leading-tight" data-id="element-68">
          No te falta paciencia: <br className="hidden md:block" data-id="element-69" />
          <span className="italic text-terracotta-dark" data-id="element-70">
            te sobra activación.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-charcoal-light mb-12 font-serif italic" data-id="element-71">
          El ritual de 10 minutos que te baja el pecho antes del grito.
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-left space-y-6 text-lg text-charcoal-light leading-relaxed mb-12 bg-white/50 p-6 md:p-8 rounded-2xl border border-terracotta/10 shadow-sm backdrop-blur-sm" data-id="element-72">
          <p data-id="element-73">Si sos mamá, ya conocés ese segundo.</p>
          <p data-id="element-74">
            El segundo en el que te escuchás por dentro decir: "No me sale."
          </p>
          <p data-id="element-75">
            Y después… sale igual. La voz alta. La respuesta cortante. El grito.
          </p>
          <p data-id="element-76">Y cuando se apaga el ruido, queda lo peor: tu culpa.</p>
          <p data-id="element-77">
            La mayoría intenta arreglarlo con la mente: "Mañana voy a tener
            paciencia."
          </p>
          <p data-id="element-78">
            Pero en el momento real —con sueño, con ruido, con mil cosas encima—
            tu mente no está al mando.
          </p>
          <p className="font-medium text-charcoal" data-id="element-79">
            Tu cuerpo ya entró en modo alarma.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-80">
          <CTAButton text="Quiero bajar antes de explotar" size="large" data-id="element-81" />
        </motion.div>
      </div>
    </section>;
}